import axios from 'axios';
import { useAuthStore } from '../store/auth.store';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  // withCredentials: true, // Removed for local development - using JWT tokens instead
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add the auth token to headers
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors and redirect to login
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth state
      const authStore = useAuthStore.getState();
      authStore.logout();
      
      // Redirect to login page, preserving current path for post-login redirect
      const currentPath = window.location.pathname;
      const loginPath = '/login';
      const redirectPath = currentPath !== '/login' && currentPath !== '/register' 
        ? `${loginPath}?redirect=${encodeURIComponent(currentPath)}`
        : loginPath;
      
      window.location.href = redirectPath;
    }
    return Promise.reject(error);
  }
);
